import axios from 'axios';

const syncBuyerShowings = async ({
  appointmentIds,
}: {
  appointmentIds?: string[];
}) => {
  const config = {
    url: `/almanac/buyer_showings`,
    method: 'post' as const,
    data: {
      appointmentIds: appointmentIds?.length ? appointmentIds : undefined,
    },
  };

  await axios.request(config);
};

export default syncBuyerShowings;
